<template>
    <ul class="pcb-select-container">
        <pcb-item v-for="item in dicDataFilter" :minWidth="minWidth" v-bind="item" :key="item.value" @click="handleSelect(item)"
        :checked="modelValue.includes(item.value)"
        >
            {{ item?.label }}
        </pcb-item>
        <div v-if="footer" v-html="footer"></div>
    </ul>
</template>
<script setup>
import PcbItem from "./pcb-item.vue"
import {inject,computed,unref,toRaw} from "vue"
defineOptions({
  name:"pcb-checkbox"
})
const modelValue = defineModel({
    default:()=>[]
})
const events=inject("events")
const props = defineProps({
  dicData: {
    type: Array,
    default: () => []
  },
  footer:{
    type:String,
    default:''
  }  ,
  minWidth:{
    type:Number,
  },
})
const dicDataFilter=computed(()=>{
  return props.dicData.filter(item=>{
    return item.display??true
  })
})
const emit = defineEmits(['change','dicClicked'])

const handleSelect = (item) => {
  let newModelValue;
  // 如果当前项已经选中，则取消选中
  if (modelValue.value.includes(item.value)) {
    newModelValue = modelValue.value.filter(value => value !== item.value);
  } else {
    // 如果当前项未选中，则选中
    newModelValue = [...modelValue.value, item.value];
  }
  if(item?.field){
    events.set(item.field,modelValue.value.includes(item.value)?false:true)
  }
  // 更新 modelValue
  emit("update:modelValue", newModelValue);
  emit("change", newModelValue);
  emit("dicClicked", toRaw(item));

}
</script>


<style lang="less">
.pcb-select-container{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 6px;
    margin: 0;
    padding: 0;
    list-style: none;
    
    // 清除默认的ul样式
    li {
        list-style: none;
    }
}
</style>